import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getLocationList = createAsyncThunk('/thunk/get-location-list', async () => {
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-location-list`,{page:1})
        return response
    } catch (error) {
        throw error
    }});    